module.exports = {
  SUPPORTED_DATELOCALES: [
    'en',
    'en-au',
    'en-ca',
    'en-gb',
    'fr',
    'es',
    'es-us',
    'de',
    'nl',
    'pt-br',
  ],
}
